// ── 공지사항 / 패치노트 데이터 ─────────────────────────────
// 새 공지 추가 시 이 파일에만 추가하면 됩니다.
// id: 고유값 (영문+숫자, URL slug로 사용 → /notice/[id])
// type: "patch" | "notice" | "event"
// pinned: 상단 고정 여부
//
// ── SEO 가이드 ──────────────────────────────────────────────
// 제목: 검색 키워드 포함 (메이플스토리, 보스, 파밍, 메소 등)
// 요약: 80자 내외, 핵심 기능 언급
// 본문: 300자 이상, ## H2 / ### H3 구조 사용
// 이미지 파일명: boss-crystal-price-2026.png (✅) / image001.png (❌)
// 이미지 alt: 게시글 제목 + 키워드 포함

export const NOTICES = [
  {
    id: "patch-0-5-5",
    type: "patch",
    pinned: false,
    title: "메이플 파밍 트래커 ver.0.5.5 — 경매장 메포 입력 / 환전 가시성 개선 / 후원 창구 오픈",
    date: "2026-08-17",
    summary: "경매장 타서버 구매 시 메이플포인트 자동 계산, 환전 획득/지출 분리 표시, 후원 창구가 추가되었습니다.",
    content: `## ✨ 신규 기능

### 후원 창구 오픈 ☕

메이플 파밍 트래커는 광고 없이 운영되는 완전 무료 서비스입니다. 설정 탭에 개발자 후원 창구가 추가되었습니다. 카카오페이 송금 링크, 계좌이체, 기프티콘/커피 후원 세 가지 방식으로 후원하실 수 있습니다. 후원해주신 금액은 Firebase 서버 유지비와 기능 개선에 사용됩니다. 기프티콘 사진 업로드 시 관리자만 확인할 수 있으며, 개인정보는 철저히 보호됩니다.

---

## 🔧 개선 사항

### 경매장 타서버 구매 — 메이플포인트 자동 계산

메이플스토리 경매장에서 타서버 아이템을 구매할 때는 메소와 메이플포인트(MP)를 함께 소모합니다. 기존에는 메포 입력란이 없어 조회/수정 탭에서 별도로 수정해야 하는 불편함이 있었습니다. 이번 업데이트로 경매장 구매 탭에서 메소와 메이플포인트를 함께 입력하면 **1억당 메포 단가가 자동으로 계산**됩니다. 예를 들어 3억 메소 + 7,500 MP로 구매했다면 1억당 2,500 MP라는 단가가 즉시 표시됩니다. 경매장 구매 기록에 캐릭터 선택 드롭다운도 추가되어 캐릭터별 지출 관리가 가능해졌습니다.

### 환전 탭 가시성 개선

메이플스토리 메소↔캐시 환전 기록의 가시성을 개선했습니다. 기존에는 늘어난 금액만 표시되어 실제로 무엇을 잃고 무엇을 얻었는지 한눈에 파악하기 어려웠습니다. 이제 **획득한 것과 지출한 것이 모두 명확하게 표시**됩니다.

- 💰 획득 메소: +300,000,000
- 💸 지출 캐시: −7,500 캐시
- 📊 억당 캐시 단가: 2,500 캐시/억

조회/수정 탭 환전 기록 상세에서도 억당 캐시 단가가 함께 표시됩니다.

---

## 🐛 버그 수정

### 경매장 구매 기록 조회 불가 문제 해결

경매장 구매 기록 저장 시 캐릭터 정보(닉네임, 직업, 월드)가 누락되어 조회/수정 탭에서 해당 기록이 보이지 않던 문제를 수정했습니다. 이제 경매장 구매 탭에서 캐릭터를 선택하면 해당 캐릭터의 기록으로 정상 저장됩니다.`,
    images: [],
    keywords: ["메이플스토리 경매장 메포", "타서버 구매 메이플포인트", "메소 캐시 환전 계산", "메이플 파밍 트래커"],
  },
  {
    id: "patch-0-5-4",
    type: "patch",
    pinned: false,
    title: "메이플 파밍 트래커 ver.0.5.4 — 그랜드 어센틱 심볼 / 물욕템 수수료 즉시 계산",
    date: "2026-08-14",
    summary: "그랜드 어센틱 심볼 강화 비용 계산기 추가, 물욕템 탭에서 경매장 수수료 즉시 자동 계산 기능 추가.",
    content: `## ✨ 신규 기능

### 그랜드 어센틱 심볼 강화 비용 계산기 추가

메이플스토리 그랜드 어센틱 포스 심볼이 지출 탭 심볼업 계산기에 추가되었습니다. 기존 아케인 포스, 어센틱 포스에 이어 **🔮 GRAND** 탭이 신설되었으며, 탈라하트와 기어드락 두 지역의 레벨 1~10 강화 비용을 자동으로 계산합니다. 그랜드 어센틱 심볼은 아케인/어센틱 심볼과 달리 주스탯을 직접 올려주지 않으며, 해당 안내 문구가 UI에 표시됩니다. 현재 레벨과 목표 레벨을 입력하면 필요한 심볼 조각 수와 총 메소 비용을 한눈에 확인할 수 있습니다.

---

## 🔧 개선 사항

### 물욕템 탭 — 경매장 수수료 즉시 자동 계산

기존에는 물욕템(보스 드롭 아이템)을 수익 탭에 입력할 때 경매장 수수료를 별도로 계산해야 했습니다. 유저분의 건의사항을 반영하여 물욕템 탭에서도 **판매 등록가 입력 즉시 수수료가 자동 계산**됩니다. 경매장 탭과 동일한 계산 방식이 적용됩니다.

- 수수료율 3% / 5% 선택 가능 (경매장 탭과 동기화)
- 보증금 2,000 메소 자동 적용
- 개당 내림차 계산 후 수량 곱하기 방식으로 인게임과 동일하게 적용
- 판매등록가 → 보증금 → 수수료 → 보증금반환 → 실수령액 순서로 즉시 표시
- 수량 +/- 버튼으로 편리하게 조절 가능
- 즉시 수익 반영 체크 시 실수령액 기준으로 수익에 바로 합산

---

## 🐛 버그 수정

물욕템 탭 진입 시 흰 화면이 표시되는 오류를 수정했습니다. calcNetPrice 함수 선언 위치 문제(TDZ 오류)였으며, 전역 선언으로 이전하여 해결했습니다.`,
    images: [],
    keywords: ["그랜드 어센틱 심볼 강화 비용", "탈라하트 기어드락 심볼", "메이플 경매장 수수료 계산기", "물욕템 수수료"],
  },
  {
    id: "patch-0-5-3",
    type: "patch",
    pinned: false,
    title: "메이플 파밍 트래커 ver.0.5.3 — 스우 이상 보스 드롭 전면 수정 / 에픽던전 자동화 / 경매장 개선",
    date: "2026-08-10",
    summary: "스우 이상 주간보스 드롭 물욕템 데이터 전면 재정리, 에픽던전 세라자르 주화 수익 자동 계산, 경매장 수수료 계산 방식 개선.",
    content: `## ✨ 신규 기능

### 에픽던전 세라자르 주화 수익 자동 계산

메이플스토리 에픽던전(하이마운틴, 앵글러 컴퍼니, 악몽선경) 클리어 보상을 수익 탭에서 자동으로 계산할 수 있습니다. 수익 유형에서 **에픽던전주화**를 선택하면 던전과 보너스 옵션에 따라 세라자르 주화 개수와 메소 수익이 자동 계산됩니다.

- 세라자르 주화 개당 4,000만 메소 기준 자동 계산
- EXP 보너스 Lv.0 / Lv.1 / Lv.2 선택
- 솔에르다 보너스 Lv.0 / Lv.1 / Lv.2 선택
- 솔에르다 기운은 X / Y 형식으로 표기 (예: 9 / 0 = 솔에르다 9개)
- 사용한 메이플포인트 입력 시 지출로 자동 별도 기록

---

## 🔧 개선 사항

### 스우 이상 주간보스 드롭 물욕템 전면 재정리

이전 패치에서 잘못 기입되었던 스우 이상 주간보스의 드롭 아이템 목록을 전면 재정리했습니다. 정심심 블로그(2026.04.21 기준) 데이터를 기반으로 검증했으며, 특히 반지 상자 드롭 난이도가 정확히 수정되었습니다.

주요 수정 보스: 스우, 데미안, 루시드, 윌, 더스크, 진 힐라, 듄켈, 검은 마법사, 선택받은 세렌, 감시자 칼로스, 최초의 대적자, 카링, 찬란한 흉성, 림보, 발드릭스, 유피테르

- 스우: 노멀=녹옥, 하드=홍옥, 익스트림=백옥 반지 상자로 정확히 구분
- 선택받은 세렌: 노멀=흑옥, 하드/익스트림=백옥으로 수정
- 감시자 칼로스: 이지/노멀=백옥, 카오스/익스트림=생명으로 분리
- 카링: 이지/노멀=백옥, 하드/익스트림=생명으로 분리

### 경매장 판매 수수료 계산 개선

메이플스토리 경매장 판매 계산이 인게임과 동일한 구조로 개선되었습니다. 보증금 2,000 메소는 등록 수량과 무관하게 1회 고정 적용되며, 수수료는 개당 내림차 계산 후 수량을 곱하는 방식으로 적용됩니다. 판매 수익(순수익)과 실수령액(보증금 반환 포함)을 분리하여 표시합니다.`,
    images: [],
    keywords: ["메이플 에픽던전 세라자르 주화", "보스 반지 상자 드롭", "경매장 수수료 계산", "메이플 보스 물욕템"],
  },
  {
    id: "patch-0-5-2",
    type: "patch",
    pinned: false,
    title: "메이플 파밍 트래커 ver.0.5.2 — 보스 드롭 아이템 체크 / 반지 상자 레벨 기록 / 캐릭터 이동",
    date: "2026-07-25",
    summary: "보스 드롭 아이템 체크 UI 추가, 반지 상자 레벨과 링 종류 선택 기능, 캐릭터 이동 기능이 추가되었습니다.",
    content: `## ✨ 신규 기능

### 보스 드롭 아이템 자동 기록

메이플스토리 보스 공략 후 얻은 드롭 아이템을 수익 탭에서 바로 기록할 수 있습니다. 보스 체크 후 **💎 드롭 아이템 ▼** 버튼을 누르면 해당 보스와 난이도에서 드롭 가능한 아이템 목록이 표시됩니다. 체크한 아이템은 보스 저장 시 물욕템 보관함에 자동으로 추가됩니다.

### 반지 상자 레벨 및 링 종류 기록

보스 드롭 아이템 중 반지 상자(녹옥/홍옥/흑옥/백옥/생명의 보스 반지 상자)를 체크하면 획득한 레벨(1~4레벨)과 링 종류를 선택할 수 있는 UI가 표시됩니다. 리스트레인트 링, 컨티뉴어스 링, 웨폰퍼프 링 등 31종의 링을 각각의 획득 확률과 함께 선택할 수 있으며, 기록된 내용은 조회/수정 탭에서 확인하고 수정할 수 있습니다.

### 캐릭터 이동 기능

실수로 다른 캐릭터로 저장한 기록을 손쉽게 이동할 수 있습니다. 조회/수정 탭에서 기록 상세를 열고 **👤 이동** 버튼을 누르면 즐겨찾기 캐릭터 목록이 표시됩니다. 원하는 캐릭터를 선택하면 닉네임, 직업, 월드 정보만 변경되고 메소, 솔에르다, 보스 목록 등 실제 데이터는 그대로 유지됩니다.

---

## 🔧 개선 사항

- 보스 결정석 가격 날짜별 자동 분기 오류 수정 (2026년 6월 24일 패치 반영)
- 검은 마법사 결정석 가격 수정: 하드 6억 6,500만 / 익스트림 87억 4,000만 메소
- 솔에르다 입력 간소화: 기운 / 사냥 / 교환불가 3가지만 유지
- 경매장 구매 탭 수량 입력 및 총금액 즉시 표시 추가`,
    images: [],
    keywords: ["메이플 보스 반지 상자", "리스트레인트 링 드롭", "메이플 물욕템 관리", "보스 드롭 기록"],
  },
  {
    id: "patch-0-5-1",
    type: "patch",
    pinned: false,
    title: "메이플 파밍 트래커 ver.0.5.1 — 프리셋 기능 / 솔에르다 간소화 / 보스 결정석 가격 수정",
    date: "2026-07-10",
    summary: "캐릭터별 보스 프리셋 저장 기능, 솔에르다 입력 간소화, 검은 마법사 등 보스 결정석 가격 수정이 포함된 업데이트입니다.",
    content: `## ✨ 신규 기능

### 보스 프리셋 저장 기능

메이플스토리 캐릭터마다 매주 가는 보스 조합을 프리셋으로 저장할 수 있습니다. 캐릭터별로 최대 3개의 프리셋 슬롯이 제공되며, PC에서는 홈 탭 우측에 위젯 형태로, 모바일에서는 홈 탭 상단에 표시됩니다. 프리셋 적용 시 해당 주간/일간/월간 기간에 이미 기록된 보스는 자동으로 제외되어 중복 기록을 방지합니다.

### 솔에르다 입력 간소화

기존 5개 항목이었던 솔에르다 입력을 **기운 / 사냥 / 교환불가** 3가지로 간소화했습니다. 메이플스토리 솔에르다 기운 1개는 1,000개 기준으로 환산되며, 짙은 솔에르다의 기운 1개는 500개로 자동 계산됩니다. 기존 기록은 모두 보존됩니다.

---

## 🔧 개선 사항

### 보스 결정석 가격 업데이트

2026년 6월 18일 패치 이후 변경된 메이플스토리 보스 결정석 가격이 반영되었습니다.

- 검은 마법사 하드: 6억 6,500만 메소
- 검은 마법사 익스트림: 87억 4,000만 메소
- 힐라 하드, 핑크빈 카오스, 시그너스가 일간보스로 이동하여 섹션 분류 수정
- 드롭 아이템 수익 자동 계산 추가 (순록의 우유, 황혼의 이슬, 새벽의 이슬, 살살녹는 치즈)`,
    images: [],
    keywords: ["메이플 보스 결정석 가격", "검은 마법사 결정석", "솔에르다 기운 계산", "메이플 주간보스 프리셋"],
  },
];

export function getNotices() {
  return [...NOTICES].sort((a,b)=>{
    if(a.pinned&&!b.pinned) return -1;
    if(!a.pinned&&b.pinned) return 1;
    return b.date.localeCompare(a.date);
  });
}

export function getNoticeById(id) {
  return NOTICES.find(n=>n.id===id)||null;
}
